import React from 'react';
import { useSelector } from 'react-redux';
import { t } from 'Src/i18n';
import { i18nSelector } from 'Store/cms/cms.selector';
import {
  LEGAL_INFO_WEBTHEO_ID,
  LEGAL_INFO_NDC_ID,
  LEGAL_INFO_NDCX_ID,
  LEGAL_INFO_THEO_ID,
} from 'Utils/booking-process/constants';
import { TRAIN } from 'Components/widgets/transport-details/transportUtils';
import { Notification } from 'Components/frameworks/notification/Notification';
import { Text } from 'Components/frameworks/text/Text';
type TransportDetailsProps = {
  transportDetailEnriched: TransportDetailEnriched;
};

function getLegalInfoForCancellationPolicy(
  bookingProcess: I18N['bookingProcess'],
  policyType: string,
): LegalInformation | undefined {
  return (bookingProcess || []).find((legal) => legal.id === policyType);
}

function getCancellationPolicyTestId(policyType: string): string {
  if (policyType === LEGAL_INFO_WEBTHEO_ID || policyType === LEGAL_INFO_THEO_ID) {
    return 'TheoCancellationPolicyNotification';
  }
  if (policyType === LEGAL_INFO_NDC_ID) {
    return 'ndcPolicyType';
  }
  if (policyType === LEGAL_INFO_NDCX_ID) {
    return 'ndcxPolicyType';
  }
  return 'cancellationPolicyNotification';
}

export const TransportDetailsWarning = ({ transportDetailEnriched }: TransportDetailsProps) => {
  const i18n = useSelector(i18nSelector);
  const isCharter = transportDetailEnriched.travelSections.every(
    ({ isClubmedTransport }) => isClubmedTransport,
  );
  const isTrain = transportDetailEnriched.travelSections.find((el) => el.transport.type === TRAIN);

  if (isCharter && !isTrain) {
    return (
      <Notification
        className="my-10 w-full px-20 py-10 text-black"
        data-testid="voyageNotification"
        iconWidth="1.5rem"
      >
        <Text
          className="text-black"
          text={t('booking.transport.charterTransportLabel')}
          theme="text-sans-n1"
        />
      </Notification>
    );
  }

  const policyType = transportDetailEnriched?.cancellationPolicyType;
  if (!policyType) {
    return null;
  }

  const legal = getLegalInfoForCancellationPolicy(i18n?.bookingProcess, policyType);
  const title = legal?.title || legal?.label;
  const description = legal?.description;

  if (!legal || (!title && !description)) {
    return null;
  }

  return (
    <Notification
      className="my-10 w-full px-20 py-10 text-black"
      data-testid={getCancellationPolicyTestId(policyType)}
      iconWidth="1.5rem"
    >
      {!!title && <div className="text-14 font-semibold">{title}</div>}
      {!!description && <Text className="text-black" text={description} theme="text-sans-n1" />}
    </Notification>
  );
};
